export const usd = (cents) => {
  const n = (Number(cents) || 0) / 100;
  return `${n < 0 ? "-" : ""}$${Math.abs(n).toFixed(2)}`;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");

export const STATUS_STYLES = {
  pending: "bg-amber-500/15 text-amber-200 border-amber-500/40",
  needs_review: "bg-orange-500/15 text-orange-200 border-orange-500/40",
  available: "bg-emerald-500/15 text-emerald-200 border-emerald-500/40",
  approved: "bg-emerald-500/15 text-emerald-200 border-emerald-500/40",
  paid: "bg-sky-500/15 text-sky-200 border-sky-500/40",
  requested: "bg-amber-500/15 text-amber-200 border-amber-500/40",
  sending: "bg-sky-500/15 text-sky-200 border-sky-500/40",
  reversed: "bg-rose-500/15 text-rose-200 border-rose-500/40",
  rejected: "bg-rose-500/15 text-rose-200 border-rose-500/40",
  suspended: "bg-rose-500/15 text-rose-200 border-rose-500/40",
  void: "bg-gray-500/15 text-gray-300 border-gray-500/40",
};

export const StatusPill = ({ status, testId }) => (
  <span data-testid={testId} className={`text-[11px] px-2 py-0.5 rounded-full border whitespace-nowrap ${STATUS_STYLES[status] || STATUS_STYLES.void}`}>
    {String(status || "").replace("_", " ")}
  </span>
);
